"use client"

import { Tally3 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Tally3Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Tally3Icon = component(Icon)({ as: Tally3 })
